export default (value) => {
  const fechaActual = new Date()
  const fechaObjetivo = new Date(value + 'T00:00:00')

  const milisegundosFechaActual = fechaActual.getTime()
  const milisegundosFechaObjetivo = fechaObjetivo.getTime()


  const diferenciaMilisegundos = milisegundosFechaObjetivo - milisegundosFechaActual

  // Calculamos la diferencia en días
  const diasRestantes = Math.ceil(diferenciaMilisegundos / (1000 * 60 * 60 * 24))

  return diasRestantes
}



// WEBPACK FOOTER //
// ./src/filtros/diasFaltantes.js